import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取提现对账列表
   */
  getList(
    MaxResultCount: number,
    currentPage: number,
    OrderNo?: string,
    CheckStatus?: number
  ) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
      OrderNo,
      CheckStatus
    }
    return Ajax.get(`/api/OrderManagement/orderLogs`, {
      params: params
    })
  },
  // 新接口
  getList2(
    MaxResultCount: number,
    currentPage: number,
    OrderNo?: string,
    CheckStatus?: number,
    startTime?: string,
    endTime?: string
  ) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
      OrderNo,
      CheckStatus,
      startTime,
      endTime
    }
    return Ajax.get(`/api/OrderManagement/orderLogs/pagedList`, {
      params: params
    })
  },
  /**
   * 佣金统计表
   */
  commissionList(startTime: string, endTime: string, MaxResultCount: number, currentPage: number) {
    let params = { 
      MaxResultCount, 
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount, 
      startTime,
      endTime
    }
    return Ajax.get('/api/distribution/distributionOrder/BrokerageReport', {
      params: params
    })
  },
  /**
   * 提佣统计表
   */
  statisCommissionList(startTime: string, endTime: string, MaxResultCount: number, currentPage: number) {
    let params = { 
      MaxResultCount, 
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
      startTime,
      endTime
    }
    return Ajax.get('/api/distribution/withdrawRecord/WithdrawReport', {
      params: params
    })
  },
  /**
   * 导出excel表格 提佣统计表
   * @param startTime 
   * @param endTime 
   * @param MaxResultCount 
   * @param currentPage 
   */
  exportWidthdrawReportFile(MaxResultCount: number, currentPage: number, startTime?: string, endTime?: string) {
    let params = {
      startTime,
      endTime,
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
    }
    return Ajax.get('/api/distribution/withdrawRecord/exportWithdrawReportFile', {
      params: params,
      responseType: "blob"
    })
  },
   /**
   * 导出excel表格 佣金统计表
   * @param startTime 
   * @param endTime 
   * @param MaxResultCount 
   * @param currentPage 
   */
  exportBrokerageReportFile(MaxResultCount: number, currentPage: number, startTime?: string, endTime?: string) {
    let params = {
      startTime,
      endTime,
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
    }
    return Ajax.get('/api/distribution/distributionOrder/exportBrokerageReportFile', {
      params: params,
      responseType: "blob"
    })
  },
  // 异步导出excel表格
  exportExcelSync(MaxResultCount: number, currentPage: number, startTime?: string, endTime?: string) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
    }
    if(startTime) {
      params['startTime'] = startTime
    }
    if(endTime) {
      params['endTime'] = endTime
    }
    return Ajax.post('/api/distribution/distributionOrder/CreateBrokerageReport', params)
  },
  /**
   * 根据分销员id查看详情
   * @param UserId 
   */
  commissionListItemDetail(startTime: string, endTime: string, UserId: string, MaxResultCount: number, currentPage: number) {
    let params = {
      startTime,
      endTime,
      UserId,
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount
    }
    return Ajax.get('/api/distribution/distributionOrder/DistributionOrderReport', {
      params: params
    })
  },
  /**
   * 审核对账
   * @param id
   * @param data
   */
  updateCheckStatus(data: {
    ids: string[]
    checkStatus: number
    remark: string
  }) {
    return Ajax.put(`/api/OrderManagement/orderLogs`, data)
  },

  exportExcel(MaxResultCount: number,
    currentPage: number,
    OrderNo?: string,
    CheckStatus?: number,
    StartTime?: string,
    EndTime?: string
  ) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
      OrderNo,
      CheckStatus,
      StartTime,
      EndTime
    }
    return Ajax.get('/api/OrderManagement/orderLogs/exportOrderLogFile', {
      params: params,
      responseType: "blob"
    })
  },
  // 异步导出对账单
  exportExcelSyncReconcliation(
    MaxResultCount: number,
    currentPage: number,
    OrderNo?: string,
    CheckStatus?: number,
    StartTime?: string,
    EndTime?: string
  ) {
    let params = {
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
    }
    if(OrderNo) {
      params['OrderNo'] = OrderNo
    }
    if(OrderNo) {
      params['CheckStatus'] = CheckStatus
    }
    if(OrderNo) {
      params['StartTime'] = StartTime
    }
    if(OrderNo) {
      params['EndTime'] = EndTime
    }
    return Ajax.post('/api/OrderManagement/orderLogs/CreateExportOrderLogsTask', params)
  }
}
